import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { TableComponentModule } from '../../main-view/table.module';
import { ButtonModule } from 'primeng-lts/button';
import { MenuModule } from 'primeng-lts/menu';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { DossierProgressGraphComponent } from './dossierProgressGraph.component';
import { ChartModule } from 'primeng-lts/chart';

@NgModule({
  declarations: [DossierProgressGraphComponent],
  imports: [
    TranslateModule,
    CommonModule,

    PanelModule,
    MenuModule,
    ButtonModule,
    ScrollPanelModule,
    TableComponentModule,
    ChartModule,
  ],
  exports: [DossierProgressGraphComponent],
})
export class DossierProgressGraphModule {}
